import Marquee from 'react-fast-marquee';

const items = [
  'Quality Craftsmanship',
  'Residential & Commercial',
  'Alpha Tex',
  'Licensed · Insured · Bonded',
  'Design-Build Studio',
  'Since 2010',
];

export default function EditorialMarquee() {
  return (
    <section aria-label="Marquee" className="relative py-14 border-y border-black/10 bg-[#0A0A0A] overflow-hidden">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span key={i} className="font-display uppercase text-white/25 text-6xl md:text-8xl mx-10 leading-none flex items-center gap-10">
            {t}
            <span className="w-3 h-3 rounded-full bg-[#DC2626]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
